import { Antrag } from '../../types';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hasAllMandatoryPages',
  standalone: true,
})
export class HasAllMandatoryPagesPipe implements PipeTransform {
  public transform(
    antrag: Antrag, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    justSomethingToTrickChangeDetection: number,
  ): boolean {
    if (!antrag.isFeatureDedicatedBelegEnabledOnAntrag || !antrag.isLangantrag) {
      return true;
    }

    const mandatoryPages = antrag.firstBelegMandatoryConfig.mandatoryPages;
    if (mandatoryPages === 0 && antrag.belege[0].seiten.length > 0) {
      return true;
    }

    return antrag.belege[0].seiten.length === mandatoryPages;
  }
}
